import React from 'react';

const ProductShowcase = () => {
  return (
    <section className="product-section">
      <h2>Functional Mushroom Formulations</h2>
      <div className="product-showcase">
        <div className="product-image">
          <img
            src="/stock/pexels-moklebust-33756340.jpg"
            alt="MindLever Mushroom Extract Capsules"
          />
        </div>
        <div className="product-details">
          <h3>Medicinal Mushroom Extract Powders</h3>
          <p>
            Experience the benefits of concentrated mushroom extracts from the Kootenays. Each product
            features carefully selected medicinal mushrooms processed into potent extract powders for
            maximum bioavailability. Available in various strengths to suit your individual wellness needs.
          </p>
          <ul className="product-benefits">
            <li>Concentrated extract powders, not ground mushrooms</li>
            <li>Rich in beta-glucans and polysaccharides</li>
            <li>Sustainably wildcrafted from BC forests</li>
            <li>Multiple dosage options available</li>
            <li>Vegan capsules, minimal fillers</li>
          </ul>
          <p className="sold-out-text" style={{color: '#721c24', fontWeight: '500', marginBottom: '15px'}}>Currently Sold Out</p>
          <div className="cta-buttons">
            <button className="btn btn-primary" disabled>Shop Now</button>
            <button className="btn btn-secondary" disabled>Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
